module.exports = __webpack_public_path__ + "media/img/info-83eff16cd28ea54a841abb227864496d.svg";